<template lang="pug">
  header#header
    .header__logo(v-show="currentPage === 'Analysis'")
      a.text-hide(href="./") 信義房屋 - 全台唯一直營上市房仲品牌

</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mixins } from '@/utils/mixins';
export default {
  name: 'Header',
  mixins: [mixins],
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['currentPage']),
  },
  methods: {
    ...mapMutations([]),
  },
}
</script>

<style lang="scss" scoped>

#header {

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  z-index: 3;

  .header {

    &__logo {

      margin: vwXL(31) 0 0 vwXL(43);

      @include desktop {
        // display: block!important;
      }

      @include tablet {
        margin: vw(31) 0 0 vw(27);
      }

      a {
        display: block;
        // width: 100%;
        // height: 100%;
        width: vwXL(185);
        height: vwXL(64);
        background-image: url('~@/assets/images/header/logo.png');
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: contain;
        @include tablet {
          width: vw(185);
          height: vw(64);
        }
      }

    }

  }

}

</style>
